export default {
  BOOLEAN: 'boolean',
  BELONGS_TO: 'belongsTo',
  NUMBER: 'number',
  STEPPER: 'stepper',
  TEXT: 'text',
  TEXTAREA: 'textarea',
  MONEY: 'money',
  DATETIME: 'datetime',
  SELECT: 'select',
  MULTISELECT: 'multiselect',
  HIDDEN: 'hidden',
}
